import { render, staticRenderFns } from "./depart.vue?vue&type=template&id=2454c0d5&scoped=true"
import script from "./depart.vue?vue&type=script&lang=js"
export * from "./depart.vue?vue&type=script&lang=js"
import style0 from "./depart.vue?vue&type=style&index=0&id=2454c0d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454c0d5",
  null
  
)

export default component.exports